module.exports = __webpack_public_path__ + "0b78203149cab51c101f395cb6bc98a3.fbx";